/* eslint-disable react-hooks/exhaustive-deps */
import { Fade, FormControl, Grow, MenuItem, OutlinedInput, Select, Stack, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Label from '../../Label/Label';
import Error from '../../Error/Error';
import { Fragment, useEffect, useState } from 'react';
import Question from '../../Question/Question';
import { changeCurrentErrorMessage, changeIsButtonEnabled, changeStepsDataEmprunteur } from '../../../redux/actions';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import '../ParcoursEmprunteur.scss';


const questions = [
    <Fragment>
        <p style={{ fontSize: 16 }}>
            Bonjour, je m’appelle Julia. En quelques questions, je vais vous proposer une offre sur-mesure et vous accompagner dans la création du contrat qui vous protègera au meilleur prix !
            <br /> <br /> Chaque adresse représente un niveau de risque différent, quelle est l’adresse du bien que vous souhaitez assurer ?
        </p>
    </Fragment>,
    <Fragment><p style={{ fontSize: 16 }}>Quel type de bien est financé par ce prêt ?</p></Fragment>
];

const replaceNullWithEmptyString = (obj: any) => {
    for (let key in obj) {
        if (obj[key] === null) {
            obj[key] = "";
        }
    }
    return obj;
};


export default function InfoBien() {
    const dispatch = useDispatch();
    const stepEmprunteur = useSelector((store: any) => store.stepEmprunteur.stepEmprunteur);
    const currentSubstep = useSelector((store: any) => store.currentSubstep.currentSubstep);
    const initDataEmprunteur = useSelector((store: any) => store.initDataEmprunteur.initDataEmprunteur);
    const stepsDataEmprunteur = useSelector((store: any) => store.stepsDataEmprunteur.stepsDataEmprunteur);
    const currentErreurMessage = useSelector((store: any) => store.currentErreurMessage.currentErreurMessage);

    const [data, setData] = useState<any>(stepsDataEmprunteur["informations-bien"]);
    const [dataAdresse, setDataAdresse] = useState<any>(
        replaceNullWithEmptyString(stepsDataEmprunteur["informations-bien"]["adresse_future"])
    );


    useEffect(() => {
        window.scroll(0, 0);
        dispatch(changeIsButtonEnabled(false));
        const inputElement = document.querySelector('.google-places-autocomplete__input');
        if (inputElement) {
            inputElement.addEventListener('input', (event: any) => {
                handleDataAdresse({ adresse: event.target.value });
            });
        }
        return () => {
            dispatch(changeCurrentErrorMessage(currentErreurMessage ?? null));
            dispatch(changeIsButtonEnabled(false));
            if (inputElement) {
                inputElement.removeEventListener('input', handleDataAdresse);
            }
        }
    }, []);

    useEffect(() => {
        dispatch(changeStepsDataEmprunteur({ ...stepsDataEmprunteur, "informations-bien": data }));
        if (isStepDataValid()) {
            dispatch(changeIsButtonEnabled(true));
        } else {
            dispatch(changeIsButtonEnabled(false));
        }
    }, [data]);

    useEffect(() => {
        setData((prevState: any) => ({ ...prevState, adresse_future: dataAdresse }));
    }, [dataAdresse]);

    useEffect(() => {
        if (isStepDataValid()) {
            dispatch(changeIsButtonEnabled(true));
        } else {
            dispatch(changeIsButtonEnabled(false));
        }
    }, [currentSubstep]);


    const setStepData = (key: string, value: any) => {
        setData((prevState: any) => ({
            ...prevState,
            [key]: value,
        }));
    };

    const isStepDataValid = () => {
        if (currentSubstep === 0) {
            return (
                dataAdresse["adresse"] !== "" &&
                dataAdresse["ville"] !== "" &&
                dataAdresse["pays"] !== "" &&
                dataAdresse["code_postal"] !== ""
            );
        }
        else {
            return data["objet_du_financement"];
        }
    };

    const handleDataAdresse = (addressObject: { [key: string]: any }) => {
        const newDataAdresse = { ...dataAdresse }
        for (const key in addressObject) {
            if (addressObject.hasOwnProperty(key)) {
                newDataAdresse[key] = addressObject[key];
            }
        }
        setDataAdresse(newDataAdresse);
    };

    const handleSelectAdresse = (suggestion: any) => {
        const adresseObject = {
            adresse: suggestion.description,
            ville: suggestion.terms.length > 1 ? suggestion.terms[suggestion.terms.length - 2].value : suggestion.terms[0].value
        }
        handleDataAdresse(adresseObject);
    };


    return (
        <Stack spacing={2} mt={6}>
            {currentErreurMessage && (<Error error={currentErreurMessage} />)}
            {((): any => {
                if (currentSubstep === 0) {
                    return (
                        <Grow in={stepEmprunteur === 0} {...({ timeout: 1500 })}>
                            <Stack spacing={4}>
                                <Question question={questions[currentSubstep]} />
                                <Stack spacing={2}>
                                    <FormControl fullWidth required>
                                        <Label label={"Adresse"} />
                                        <GooglePlacesAutocomplete
                                            apiKey="AIzaSyBA1dplU9rdYSCSnwdrIFg_zuoaqcxW4Rc"
                                            placeholder="Indiquez un lieu"
                                            loader={<p className='century-bold' style={{ fontSize: 14 }}>Chargement des adresses...</p>}
                                            initialValue={data?.adresse_future?.adresse ?? ""}
                                            onSelect={handleSelectAdresse}
                                            renderSuggestions={(_active, suggestions, onSelectSuggestion) => (
                                                <div className="suggestions-container">
                                                    {suggestions.map((suggestion, index) => (
                                                        <MenuItem key={index} onClick={(event) => onSelectSuggestion(suggestion, event)}>
                                                            {suggestion.description}
                                                        </MenuItem>
                                                    ))}
                                                </div>
                                            )}
                                        />
                                    </FormControl>
                                    <Stack direction={'row'} gap={"10px"} width={"100%"} alignItems={"end"}>
                                        <FormControl fullWidth required>
                                            <Label label={"Code postal"} />
                                            <TextField variant="outlined" onChange={(event: any) => handleDataAdresse({ code_postal: event.target.value })} value={data?.adresse_future?.code_postal ?? ""} />
                                        </FormControl>
                                        <FormControl fullWidth required>
                                            <Label label={"Ville"} />
                                            <TextField onChange={(event: any) => handleDataAdresse({ ville: event.target.value })} variant="outlined" value={data?.adresse_future?.ville ?? ""} />
                                        </FormControl>
                                    </Stack>
                                    <FormControl fullWidth required>
                                        <Label label={"Pays"} />
                                        <Select
                                            labelId="demo-simple-select-label"
                                            onChange={(event: any) => handleDataAdresse({ pays: event.target.value })}
                                            input={<OutlinedInput value={data?.adresse_future?.pays ?? ""} />}
                                        >
                                            {
                                                initDataEmprunteur?.lst_pays?.map((pn: any, index: number) => (
                                                    <MenuItem value={pn} key={index}>{pn}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Stack>
                            </Stack>
                        </Grow>
                    )
                }
                if (currentSubstep === 1) {
                    return (
                        <Fade in={stepEmprunteur === 0} {...({ timeout: 1500 })}>
                            <Stack spacing={4}>
                                <Question question={questions[currentSubstep]} />
                                <FormControl fullWidth required>
                                    <Label label={"Objet du financement"} />
                                    <Select
                                        labelId="demo-simple-select-label"
                                        onChange={(event: any) => setStepData("objet_du_financement", event.target.value)}
                                        input={<OutlinedInput value={data["objet_du_financement"]} />}
                                    >
                                        {
                                            initDataEmprunteur?.ugip_objet_du_financement?.map((ob: any, index: number) => (
                                                <MenuItem value={ob} key={index}>{ob}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                            </Stack>
                        </Fade>
                    )
                }
            })()}
        </Stack>
    )
};